// extracted by mini-css-extract-plugin
module.exports = {"powerBi":"styles_powerBi__F7UgV"};